import {
  CollaboratorTypeEnum,
  CmSheetMenuEnum,
  PermissionsEnum,
  CmSheetEventEnum,
} from "../constants/AppConstants";
import { AuthProfile } from "../types/api/auth.type";
import { Role } from "../types/AppTypes";

export type PermissionRole =
  | PermissionsEnum
  | CmSheetMenuEnum
  | CollaboratorTypeEnum
  | CmSheetEventEnum;

const rolePermissionsAdmin: PermissionRole[] = [
  PermissionsEnum.SIDEBAR_MANAGEMENT,
  PermissionsEnum.EDIT_RESUME,
  PermissionsEnum.HISTORY_CM,
  PermissionsEnum.EDIT_ALL_CM_SHEETS,
  PermissionsEnum.SIDEBAR_AREA_DEVELOPMENT,
  PermissionsEnum.EDIT_TECH_FORMATION,
  PermissionsEnum.SIDEBAR_MATRIX,
  PermissionsEnum.SIDEBAR_MANAGE_CAREER,
  PermissionsEnum.SIDEBAR_COLLABORATORS,
  PermissionsEnum.SIDEBAR_TECH_SKILLS,
  PermissionsEnum.SIDEBAR_FORMATION,
  PermissionsEnum.EDIT_CM,
  PermissionsEnum.EDIT_ADMIN_COMMENT,
  PermissionsEnum.VIEW_MATRIX_PRACTICE_SELECT,
  PermissionsEnum.VIEW_MATRIX_COMPETENCE_SELECT,
  PermissionsEnum.READ_CM_SHEET_WHEN_ARCHIVED_WITH_TERMINATION,
  PermissionsEnum.RESTORE_CM_SHEET,
  PermissionsEnum.CAN_DOWNLOAD_CV_ACTIVE_RESOURSES,
  PermissionsEnum.CAN_DOWNLOAD_CV_COLLABORATOR_PROFILE,
  CmSheetMenuEnum.INTERNAL_GRADE,
  CmSheetMenuEnum.SOFT_SKILLS,
  CmSheetMenuEnum.GOALS,
  CmSheetMenuEnum.PROFESSIONAL_PATH,
  CmSheetMenuEnum.FORMATION,
  CmSheetMenuEnum.COLLABORATOR_COMMENT,
  CmSheetMenuEnum.FINAL_INTERVIEW,
  CmSheetMenuEnum.NOTE,
  CmSheetMenuEnum.ADMIN_COMMENT,
  CmSheetEventEnum.VALUTA,
  CmSheetEventEnum.CONCLUDI_SCHEDA,
  CmSheetEventEnum.INVIA_FEEDBACK,
  CmSheetEventEnum.ARCHIVIA,
  CmSheetEventEnum.TERMINA,
  CmSheetEventEnum.BACKTO_DRAFT,
  CmSheetEventEnum.BACKTO_VALUTAZIONE_INTERMEDIA,
  CmSheetEventEnum.BACKTO_CALIBRATION_FINALE,
  CmSheetEventEnum.BACKTO_FEEDBACK_FINALE,
  CollaboratorTypeEnum.ACTIVE,
  PermissionsEnum.APPROVE_COLLABORATOR_CV,
  PermissionsEnum.EDIT_COLLABORATOR_HISTORY,
  PermissionsEnum.ENABLE_HISTORY_STATS,
  PermissionsEnum.CAN_START_CALIBRATION, //NOTE: da togliere una volta rimossa la versione vecchia
  PermissionsEnum.CAN_DELETE_ASSIGN_CM,
  PermissionsEnum.CAN_START_DEVELOPMENT_COMMITTEE,
];

const rolePermissionsHr: PermissionRole[] = [
  PermissionsEnum.SIDEBAR_MANAGEMENT,
  PermissionsEnum.EDIT_RESUME,
  PermissionsEnum.HISTORY_CM,
  PermissionsEnum.EDIT_ALL_CM_SHEETS,
  PermissionsEnum.SIDEBAR_AREA_DEVELOPMENT,
  PermissionsEnum.EDIT_TECH_FORMATION,
  PermissionsEnum.SIDEBAR_MATRIX,
  PermissionsEnum.SIDEBAR_MANAGE_CAREER,
  PermissionsEnum.SIDEBAR_COLLABORATORS,
  PermissionsEnum.EDIT_CM,
  PermissionsEnum.SIDEBAR_FORMATION,
  PermissionsEnum.VIEW_MATRIX_PRACTICE_SELECT,
  PermissionsEnum.VIEW_MATRIX_COMPETENCE_SELECT,
  PermissionsEnum.READ_CM_SHEET_WHEN_ARCHIVED_WITH_TERMINATION,
  PermissionsEnum.RESTORE_CM_SHEET,
  PermissionsEnum.CAN_DOWNLOAD_CV_ACTIVE_RESOURSES,
  PermissionsEnum.CAN_DOWNLOAD_CV_COLLABORATOR_PROFILE,
  CmSheetMenuEnum.INTERNAL_GRADE,
  CmSheetMenuEnum.SOFT_SKILLS,
  CmSheetMenuEnum.GOALS,
  CmSheetMenuEnum.PROFESSIONAL_PATH,
  CmSheetMenuEnum.FORMATION,
  CmSheetMenuEnum.COLLABORATOR_COMMENT,
  CmSheetMenuEnum.FINAL_INTERVIEW,
  CmSheetMenuEnum.NOTE,
  CmSheetEventEnum.VALUTA,
  CmSheetEventEnum.CONCLUDI_SCHEDA,
  CmSheetEventEnum.INVIA_FEEDBACK,
  CmSheetEventEnum.ARCHIVIA,
  CmSheetEventEnum.TERMINA,
  CmSheetEventEnum.BACKTO_DRAFT,
  CmSheetEventEnum.BACKTO_VALUTAZIONE_INTERMEDIA,
  CmSheetEventEnum.BACKTO_CALIBRATION_FINALE,
  CmSheetEventEnum.BACKTO_FEEDBACK_FINALE,
  CollaboratorTypeEnum.ACTIVE,
  PermissionsEnum.CAN_START_CALIBRATION, //NOTE: da togliere una volta rimossa la versione vecchia
  PermissionsEnum.APPROVE_COLLABORATOR_CV,
  PermissionsEnum.EDIT_COLLABORATOR_HISTORY,
  PermissionsEnum.ENABLE_HISTORY_STATS,
  PermissionsEnum.CAN_DELETE_ASSIGN_CM,
];

const rolePermissionsAreaLeader: PermissionRole[] = [
  PermissionsEnum.SIDEBAR_AREA_DEVELOPMENT,
  PermissionsEnum.EDIT_TECH_FORMATION,
  PermissionsEnum.SIDEBAR_MATRIX,
  PermissionsEnum.SIDEBAR_MANAGE_CAREER,
  PermissionsEnum.SIDEBAR_COLLABORATORS,
  PermissionsEnum.EDIT_CM,
  PermissionsEnum.SIDEBAR_FORMATION,
  PermissionsEnum.VIEW_MATRIX_PRACTICE_SELECT,
  PermissionsEnum.VIEW_MATRIX_COMPETENCE_SELECT,
  PermissionsEnum.CAN_DOWNLOAD_CV_ACTIVE_RESOURSES,
  PermissionsEnum.CAN_DOWNLOAD_CV_COLLABORATOR_PROFILE,
  PermissionsEnum.EDIT_DEVELOPMENT_INDICATORS_CM_SHEET,
  PermissionsEnum.EDIT_DEVELOPMENT_BUSINESS_COMMENT_CM_SHEET,
  PermissionsEnum.EDIT_DEVELOPMENT_INCREASINGS_CM_SHEET,
  PermissionsEnum.EDIT_DEVELOPMENT_FEEDBACK_TO_COLLABORATOR_CM_SHEET,
  PermissionsEnum.EDIT_PROFESSIONAL_PATH_CM_SHEET,
  CmSheetMenuEnum.INTERNAL_GRADE,
  CmSheetMenuEnum.SOFT_SKILLS,
  CmSheetMenuEnum.GOALS,
  CmSheetMenuEnum.PROFESSIONAL_PATH,
  CmSheetMenuEnum.FORMATION,
  CmSheetMenuEnum.COLLABORATOR_COMMENT,
  CmSheetMenuEnum.FINAL_INTERVIEW,
  CollaboratorTypeEnum.ACTIVE,
];

const rolePermissionsPracticeManager: PermissionRole[] = [
  PermissionsEnum.SIDEBAR_AREA_DEVELOPMENT,
  PermissionsEnum.EDIT_TECH_FORMATION,
  PermissionsEnum.SIDEBAR_MATRIX,
  PermissionsEnum.SIDEBAR_MANAGE_CAREER,
  PermissionsEnum.SIDEBAR_COLLABORATORS,
  PermissionsEnum.EDIT_CM,
  PermissionsEnum.SIDEBAR_FORMATION,
  PermissionsEnum.VIEW_MATRIX_PRACTICE_SELECT,
  PermissionsEnum.CAN_DOWNLOAD_CV_ACTIVE_RESOURSES,
  PermissionsEnum.CAN_DOWNLOAD_CV_COLLABORATOR_PROFILE,
  PermissionsEnum.ENABLE_HISTORY_STATS,
  PermissionsEnum.EDIT_PROFESSIONAL_PATH_CM_SHEET,
  PermissionsEnum.EDIT_DEVELOPMENT_INDICATORS_CM_SHEET,
  PermissionsEnum.EDIT_DEVELOPMENT_BUSINESS_COMMENT_CM_SHEET,
  PermissionsEnum.EDIT_DEVELOPMENT_INCREASINGS_CM_SHEET,
  PermissionsEnum.EDIT_DEVELOPMENT_FEEDBACK_TO_COLLABORATOR_CM_SHEET,
  CmSheetMenuEnum.INTERNAL_GRADE,
  CmSheetMenuEnum.SOFT_SKILLS,
  CmSheetMenuEnum.GOALS,
  CmSheetMenuEnum.PROFESSIONAL_PATH,
  CmSheetMenuEnum.FORMATION,
  CmSheetMenuEnum.COLLABORATOR_COMMENT,
  CmSheetMenuEnum.FINAL_INTERVIEW,
  CollaboratorTypeEnum.ACTIVE,
  PermissionsEnum.VIEW_MATRIX_COMPETENCE_SELECT,
  PermissionsEnum.VIEW_GOAL_PERCENTAGE_ACHIEVEMENT,
];

const rolePermissionsPracticeLeader: PermissionRole[] = [
  PermissionsEnum.SIDEBAR_AREA_DEVELOPMENT,
  PermissionsEnum.EDIT_TECH_FORMATION,
  PermissionsEnum.SIDEBAR_MATRIX,
  PermissionsEnum.SIDEBAR_MANAGE_CAREER,
  PermissionsEnum.SIDEBAR_COLLABORATORS,
  PermissionsEnum.EDIT_CM,
  PermissionsEnum.SIDEBAR_FORMATION,
  PermissionsEnum.CAN_DOWNLOAD_CV_ACTIVE_RESOURSES,
  PermissionsEnum.CAN_DOWNLOAD_CV_COLLABORATOR_PROFILE,
  PermissionsEnum.ENABLE_HISTORY_STATS,
  PermissionsEnum.EDIT_PROFESSIONAL_PATH_CM_SHEET,
  PermissionsEnum.EDIT_DEVELOPMENT_INDICATORS_CM_SHEET,
  PermissionsEnum.EDIT_DEVELOPMENT_BUSINESS_COMMENT_CM_SHEET,
  PermissionsEnum.EDIT_DEVELOPMENT_INCREASINGS_CM_SHEET,
  PermissionsEnum.EDIT_DEVELOPMENT_FEEDBACK_TO_COLLABORATOR_CM_SHEET,
  CmSheetMenuEnum.INTERNAL_GRADE,
  CmSheetMenuEnum.SOFT_SKILLS,
  CmSheetMenuEnum.GOALS,
  CmSheetMenuEnum.PROFESSIONAL_PATH,
  CmSheetMenuEnum.FORMATION,
  CmSheetMenuEnum.COLLABORATOR_COMMENT,
  CmSheetMenuEnum.FINAL_INTERVIEW,
  CollaboratorTypeEnum.ACTIVE,
  PermissionsEnum.VIEW_MATRIX_COMPETENCE_SELECT,
  PermissionsEnum.VIEW_GOAL_PERCENTAGE_ACHIEVEMENT,
];

const rolePermissionsCcManager: PermissionRole[] = [
  PermissionsEnum.SIDEBAR_MATRIX,
  PermissionsEnum.SIDEBAR_MANAGE_CAREER,
  PermissionsEnum.SIDEBAR_COLLABORATORS,
  PermissionsEnum.EDIT_CM,
  PermissionsEnum.SIDEBAR_FORMATION,
  PermissionsEnum.EDIT_PROFESSIONAL_PATH_CM_SHEET,
  PermissionsEnum.EDIT_DEVELOPMENT_INDICATORS_CM_SHEET,
  PermissionsEnum.EDIT_DEVELOPMENT_BUSINESS_COMMENT_CM_SHEET,
  PermissionsEnum.EDIT_DEVELOPMENT_INCREASINGS_CM_SHEET,
  PermissionsEnum.EDIT_DEVELOPMENT_FEEDBACK_TO_COLLABORATOR_CM_SHEET,
  CmSheetMenuEnum.INTERNAL_GRADE,
  CmSheetMenuEnum.SOFT_SKILLS,
  CmSheetMenuEnum.GOALS,
  CmSheetMenuEnum.PROFESSIONAL_PATH,
  CmSheetMenuEnum.FORMATION,
  CmSheetMenuEnum.COLLABORATOR_COMMENT,
  CmSheetMenuEnum.FINAL_INTERVIEW,
  CollaboratorTypeEnum.ACTIVE,
  PermissionsEnum.VIEW_MATRIX_COMPETENCE_SELECT,
  PermissionsEnum.VIEW_GOAL_PERCENTAGE_ACHIEVEMENT,
];

const rolePermissionsCcLeader: PermissionRole[] = [
  PermissionsEnum.SIDEBAR_MATRIX,
  PermissionsEnum.SIDEBAR_MANAGE_CAREER,
  PermissionsEnum.SIDEBAR_COLLABORATORS,
  PermissionsEnum.EDIT_CM,
  PermissionsEnum.SIDEBAR_FORMATION,
  PermissionsEnum.EDIT_PROFESSIONAL_PATH_CM_SHEET,
  PermissionsEnum.EDIT_DEVELOPMENT_INDICATORS_CM_SHEET,
  PermissionsEnum.EDIT_DEVELOPMENT_BUSINESS_COMMENT_CM_SHEET,
  PermissionsEnum.EDIT_DEVELOPMENT_INCREASINGS_CM_SHEET,
  PermissionsEnum.EDIT_DEVELOPMENT_FEEDBACK_TO_COLLABORATOR_CM_SHEET,
  CmSheetMenuEnum.INTERNAL_GRADE,
  CmSheetMenuEnum.SOFT_SKILLS,
  CmSheetMenuEnum.GOALS,
  CmSheetMenuEnum.PROFESSIONAL_PATH,
  CmSheetMenuEnum.FORMATION,
  CmSheetMenuEnum.COLLABORATOR_COMMENT,
  CmSheetMenuEnum.FINAL_INTERVIEW,
  CollaboratorTypeEnum.ACTIVE,
  PermissionsEnum.VIEW_GOAL_PERCENTAGE_ACHIEVEMENT,
];

const rolePermissionsCollaborator: PermissionRole[] = [
  CmSheetMenuEnum.INTERNAL_GRADE,
  CmSheetMenuEnum.SOFT_SKILLS,
  CmSheetMenuEnum.GOALS,
  CmSheetMenuEnum.PROFESSIONAL_PATH,
  CmSheetMenuEnum.FORMATION,
  CmSheetMenuEnum.COLLABORATOR_COMMENT,
  CmSheetMenuEnum.FINAL_INTERVIEW,
  PermissionsEnum.SIDEBAR_FORMATION,
  PermissionsEnum.ENABLE_HISTORY_STATS,
];

const cmPermissions: PermissionRole[] = [
  PermissionsEnum.SIDEBAR_COLLABORATORS,
  PermissionsEnum.EDIT_OWN_CM_SHEET,
  CmSheetMenuEnum.INTERNAL_GRADE,
  CmSheetMenuEnum.SOFT_SKILLS,
  CmSheetMenuEnum.GOALS,
  CmSheetMenuEnum.PROFESSIONAL_PATH,
  CmSheetMenuEnum.FORMATION,
  CmSheetMenuEnum.COLLABORATOR_COMMENT,
  CmSheetMenuEnum.FINAL_INTERVIEW,
  CmSheetEventEnum.VALUTA,
  CmSheetEventEnum.CONCLUDI_SCHEDA,
  CollaboratorTypeEnum.FOLLOW,
];

const rolePermissions: Record<Role, PermissionRole[]> = {
  [Role.ADMIN]: [...rolePermissionsAdmin],
  [Role.HR]: [...rolePermissionsHr],
  [Role.A_LEADER]: [...rolePermissionsAreaLeader],
  [Role.P_MANAGER]: [...rolePermissionsPracticeManager],
  [Role.P_LEADER]: [...rolePermissionsPracticeLeader],
  [Role.CC_MANAGER]: [...rolePermissionsCcManager],
  [Role.CC_LEADER]: [...rolePermissionsCcLeader],
  [Role.COLLABORATOR]: [...rolePermissionsCollaborator],
};

export function roleHasPermission(
  user: AuthProfile,
  action: PermissionRole,
): boolean {
  return (
    rolePermissions[user.role].includes(action) ||
    (user.isCm && cmPermissions.includes(action))
  );
}
